import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useApi, errMsg } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { PartnerKeys } from "@/components/apikeys/PartnerKeys";
import { SyncKeyPanel } from "@/components/apikeys/SyncKeyPanel";
import { UsagePanel } from "@/components/apikeys/UsagePanel";
import { ApiDocs } from "@/components/apikeys/ApiDocs";
import { AlertsPanel } from "@/components/apikeys/AlertsPanel";

export default function ApiKeysPage() {
  const api = useApi();
  const [data, setData] = useState(null);
  const load = useCallback(() => api("get", "/api-keys").then(setData).catch((e) => toast.error(errMsg(e))), [api]);
  useEffect(() => { load(); }, [load]);
  return (
    <div className="space-y-8" data-testid="api-keys-page">
      <PageHeader title="Clés API" subtitle="Ouvrez l'accès aux données à vos partenaires, contrôlez chaque clé et gérez la clé de synchronisation avec Sehatic-Pedia." />
      <Tabs defaultValue="partners">
        <TabsList className="bg-white border border-stone-200 flex-wrap h-auto">
          <TabsTrigger value="partners" data-testid="tab-partners">Clés partenaires</TabsTrigger>
          <TabsTrigger value="usage" data-testid="tab-usage">Journal des appels</TabsTrigger>
          <TabsTrigger value="alerts" data-testid="tab-alerts">Alertes e-mail</TabsTrigger>
          <TabsTrigger value="sync" data-testid="tab-sync-key">Clé de synchronisation</TabsTrigger>
          <TabsTrigger value="docs" data-testid="tab-docs">Documentation</TabsTrigger>
        </TabsList>
        <TabsContent value="partners" className="mt-6"><PartnerKeys data={data} reload={load} /></TabsContent>
        <TabsContent value="usage" className="mt-6"><UsagePanel keys={data?.keys || []} /></TabsContent>
        <TabsContent value="alerts" className="mt-6"><AlertsPanel /></TabsContent>
        <TabsContent value="sync" className="mt-6"><SyncKeyPanel /></TabsContent>
        <TabsContent value="docs" className="mt-6"><ApiDocs data={data} /></TabsContent>
      </Tabs>
    </div>
  );
}
